// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"97":"f3733d4f","327":"fdb8917d","793":"c50fe6e8","916":"ad6e1ccb"}[chunkId] + ".css";
};